import React from 'react';
import { ModalButtonSave } from '../../constant';
import { FormMicEstatus } from './FormMicEstatus';
import { Dialog } from 'primereact/dialog';
import { Button } from 'reactstrap';


export const ModalMicEstatus = (props) => {
    const {
        modal,
        modalTitle,
        closeDialog,
        method,
        loading,
        handleInputChange,
        saveCreate
    } = props;

    return (
        <Dialog
            visible={modal}
            onHide={closeDialog}
            closable={false}
            modal
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">
                        <div className="Global-dialog-icon">
                            <i className="icofont icofont-check-circled f-24"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                {modalTitle}
                            </div>
                        </div>
                    </div>
                </div>
            }
            draggable={false}
            className={`Global-dialog Global-dialog Global-blue Global-small-v38 `}
            footer={
                <>
                    {
                        method === "create" && <Button
                            color="secondary"
                            size="sm"
                            className={loading ? "disabled progress-bar-animated progress-bar-striped" : ""}
                            onClick={saveCreate}
                        >
                            {
                                loading ? "Creando...." : "Crear"
                            }
                        </Button>
                    }

                    <Button
                        size="sm"
                        color='danger'
                        type="button"
                        onClick={closeDialog}>
                        Cancelar
                    </Button>
                </>
            }
        >

            {
                method === "create" && (
                    <FormMicEstatus
                        button={ModalButtonSave}
                        {...{ closeDialog, loading, handleInputChange, methodAction: saveCreate }}
                    />
                )
            }
        </Dialog>
    );
};
